import { render, staticRenderFns } from "./CreateDocument1.vue?vue&type=template&id=510bfbe9&scoped=true&"
import script from "./CreateDocument1.vue?vue&type=script&lang=js&"
export * from "./CreateDocument1.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocument1.vue?vue&type=style&index=0&id=510bfbe9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510bfbe9",
  null
  
)

export default component.exports